import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { ListTab, SharedService } from "../../services/shared.service";
import { UserService } from "../../services/user.service";
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, ActivationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-timezone-picker',
  templateUrl: './timezone-picker.component.pug',
  styleUrls: ['./timezone-picker.component.scss']
})
export class TimezonePickerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() roles: any;
  appName: string;
  utilityRole = "UTILITY_USER";
  private routerSubscription: Subscription;

  constructor(
    private sharedService: SharedService,
    private userService: UserService,
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.applyRouteData(this.getDeepestRouteData());
    this.routerSubscription = this.router.events
      .pipe(filter((evt): evt is ActivationStart => evt instanceof ActivationStart))
      .subscribe((evt) => {
        this.applyRouteData(evt.snapshot.data);
      }
    );
  }

  private getDeepestRouteData(): any {
    let child = this.route;
    while (child.firstChild) {
      child = child.firstChild;
    }
    return child.snapshot.data;
  }

  private applyRouteData(data: any) {
    if (data.training) {
      this.selectedTZ = 1;
      this.appName = "Training Event Management";
    } else if (data.utility) {
      this.selectedTZ = 1;
      this.appName = "Utility Portal";
    } else {
      this.appName = "Event Management";
      const cookie = this.cookieService.get('etz');
      if (cookie) {
        this.selectedTZ = Number(cookie);
      }
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    if (!this.roles) {
      return;
    }
    if (this.userService.hasUtilityDispatchRole(this.roles)) {
      this.utilityRole = "UTILITY_DISPATCH_USER";
    }
  }

  get selectedTZ() {
    return this.sharedService.selectedTZ;
  }

  set selectedTZ(val: number) {
    this.sharedService.selectedTZ = val;
    this.cookieService.set('etz', this.sharedService.selectedTZ.toString(), null, '/');
    this.sharedService.changeTimeZonePref(val);
  }

  openCreatePage():void{
    const url = window.location.origin + '/create';
    window.open(url, '_blank');
  }

  openUtilityCreatePage():void{
    const url = window.location.origin + '/utility/create';
    window.open(url, '_blank');
  }

  openTrainingCreatePage():void{
    const url = window.location.origin + '/training/create';
    window.open(url, '_blank');
  }
  openAdminPage():void{
    const url = window.location.origin + '/admin';
    window.open(url, '_blank');
  }

  openUnderfrequencyPage():void{
    const url = window.location.origin + '/underfrequency-events';
    window.open(url, '_blank');
  }

  setTab(tab) {
    SharedService.me.setListTab((<any>ListTab[tab]))
  }

  getTab() {
    return SharedService.me.getListTab();
  }

  isActiveTab(num: number) {
    return (
        window.location.pathname === '/' &&
        num === this.getTab()
    );
  }

  //9 is the regular nodedetails and i'm lazy
  isUtilityTab() {
    return SharedService.me.getListTab() > 4 && SharedService.me.getListTab() < 9;
  }

  isTrainingTab() {
    return SharedService.me.getListTab() >= 10;
  }

  openSearch() {
    const url = window.location.origin + '/search';
    window.open(url, '_blank');
  }
}
